import {useEffect} from 'react'
import {Card, CardContent} from 'src/components/card'
import {Collapsible, CollapsibleContent, CollapsibleTrigger} from 'src/components/collapsible'
import {Separator} from 'src/components/separator'
import {useAppSidebar} from 'src/layouts/main-layout/app-sidebar/app-sidebar-context'
import {CompaniesSelectorButton} from 'src/layouts/main-layout/companies-selector/companies-selector-button'
import {useCompaniesSelector} from 'src/layouts/main-layout/companies-selector/companies-selector-context'
import {CompaniesSelectorList} from 'src/layouts/main-layout/companies-selector/companies-selector-list'
import {CompaniesSelectorNav} from 'src/layouts/main-layout/companies-selector/companies-selector-nav'

export function CompaniesSelector() {
  const {isCompanieSelectorCollapsed, toggleCompanieSelectorCollapsed, toggleCollapsed, collapsed} = useAppSidebar()
  const {handleSetSelectedCompanies, selectedCompanies, queryCompanies} = useCompaniesSelector()
  const {data: companies} = queryCompanies

  useEffect(() => {
    if (!selectedCompanies.length && companies?.length) {
      handleSetSelectedCompanies({id: companies[0].id, name: companies[0].name})
    }
  }, [selectedCompanies, companies])

  return (
    <Card className='bg-secondary w-full max-w-sm text-white'>
      <CardContent>
        <Collapsible
          open={isCompanieSelectorCollapsed}
          onOpenChange={() => {
            if (collapsed) toggleCollapsed()
            toggleCompanieSelectorCollapsed()
          }}>
          <CollapsibleTrigger asChild>
            <CompaniesSelectorButton />
          </CollapsibleTrigger>
          <CollapsibleContent className='data-[state=open]:animate-accordion-down data-[state=closed]:hidden data-[state=closed]:animate-accordion-up flex flex-col gap-2 overflow-hidden pb-3 transition-all duration-600 ease-in-out'>
            <Separator className='bg-sidebar-border w-full' />
            <CompaniesSelectorNav />
            <CompaniesSelectorList />
          </CollapsibleContent>
        </Collapsible>
      </CardContent>
    </Card>
  )
}
